/* global GLOBAL_PROMO_COOKIE_KEY */

import { cookie } from 'reduxModules/utils/cookie'

export const getGlobalPromoCookie = async (dispatch) => ({
  value: await dispatch(cookie(GLOBAL_PROMO_COOKIE_KEY))
})

export const setGlobalPromoCookie = async (dispatch, value) => {
  await dispatch(cookie(GLOBAL_PROMO_COOKIE_KEY, value))
}

// The server's per-plan promo entry carries discount_amount 0 wherever
// checkout would refuse the code — plan not discountable and not scoped at it
// (SPEC-062) — so this is the one place "does the promo apply here" is
// answered, with no plan id or name involved (SPEC-063).
export const promoDiscountForPlan = (globalPromo, plan) => {
  const entry = plan && globalPromo?.plans?.[plan.id]
  const amount = parseFloat(entry?.discountAmount)
  return Number.isFinite(amount) && amount > 0 ? amount : 0
}
